import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, colors, Hidden, Paper, TextField } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "../CheckBoxComponent";
import DiscountPermissions from "../discount-permissions";
import { Autocomplete } from "@material-ui/lab";
import { GetItemFromOptions } from "../../../../services/global-services";
import { useStylesLbl, useStylesTF } from "../../../../St/comps/UseStyle";
import POSPermissions from "./POS-permissions";
import { SharedGroupIdProvider } from "../../../Invs/BackEnd/InvoiceRest/RestProductsG";
import GroupLists from "../../../Invs/BackEnd/InvoiceRest/GroupLists";
import { ProductsGroups } from "../../../Invs/BackEnd/POS/ProductsGroups";
import { GroupSelectRest } from "../../../Invs/BackEnd/POS/GroupSelectRest";
import ShiftsPermission from "./ShiftsPermission";
const formData = [
  { name: "Automatic_Insert", label: "الإدخال (أوتماتيك)", visible: true },
  { name: "ShowQtyScreen", label: "اخفاء شاشة عرض الكميات", visible: false },
  {
    name: "UpdateSalePrice",
    label: "السماح بتعديل السعر عند البيع",
    visible: true,
  },
  {
    name: "sale_no_less_than_purch",
    label: "عدم السماح بسعر البيع اقل من سعر الشراء",
    visible: true,
  },
  {
    name: "sale_no_less_than_minPrice",
    label: "عدم السماح بسعر البيع اقل من السعر الأدنى",
    visible: true,
  },
  {
    name: "UpdateSaleDate",
    label: "السماح بتعديل تاريخ فاتورة البيع",
    visible: true,
  },
  {
    name: "SaleInMinus",
    label: "السماح بالبيع بدون كمية بالمخزن",
    visible: true,
  },
  {
    name: "saleVatUpdate",
    label: "السماح بتعديل الضريبة عند البيع",
    visible: true,
  },
  {
    name: "allow_salePrice_zero",
    label: "السماح بالبيع بصفر كزيادة او هدية",
    visible: true,
  },
  {
    name: "allow_return_Without_bill",
    label: "السماح بالارجاع بدون رقم فاتورة",
    visible: true,
  },
  {
    name: "allow_replace_Without_bill",
    label: "السماح بالاستبدال بدون رقم فاتورة",
    visible: true,
  },
  {
    name: "inv_post_unlock",
    label: "السماح بتعديل او حذف فاتورة بعد الترحيل",
    visible: false,
  },
  {
    // this field for users table
    name: "register_customer_no_account",
    label: "السماح بتسجيل عميل للفاتورة بدون حساب",
    visible: true,
  },
  {
    name: "allow_discount",
    label: "السماح بالخصم ",
    visible: true
  },
  {
    name: "PrintAfter_Save",
    label: "طباعة الفاتورة مباشرة بعد الحفظ",
    visible: true,
  },
  {
    name: "Purch_out_goods",
    label: "عرض طباعة تصريح خروج بضاعة  ",
    visible: true,
  },
  {
    name: "NoRepeatItem",
    label: "الفاء تجميع الاصناف",
    visible: true,
  },
  {
    name: "use_barcode_reader",
    label: "استخدام قارئ الباركود",
    visible: true,
  },
  {
    name: "Cust_SalePrice",
    label: "اعتماد اخر سعر بيع للعميل لكل صنف",
    visible: true,
  },
  {
    name: "ShowBtnCar",
    label: "إظهار مواصفات السيارة",
    visible: true,
  },
  {
    name: "return_same_invoice_date",
    label: "ارجاع الفاتورة بنفس تاريخ فاتورة البيع",
    visible: true,
  },
  {
    name: "hide_item_data",
    label: "اخفاء زر اضافة الصنف",
    visible: true,
  },
  {
    name: "hide_item_info",
    label: "اخفاء معلومات الصنف",
    visible: true,
  },
  {
    name: "cancel_payed_network",
    label: "cancel payed network",
    visible: true,
  },
  {
    name: "cancel_payed_bank",
    label: "cancel payed bank",
    visible: true,
  }, {
    name: "cancel_bill_agel",
    label: "cancel bill agel",
    visible: true,
  },
  , {
    name: "cancel_payed_emp",
    label: "cancel payed emp",
    visible: true,
  },
  // { name: "allow_discount", label: "السماح بالخصم ", visible: true },
];

export default function SalePermissions(props) {
  const { onChange, object, update, gData, accounts } = props;
  const typeSetting = [
    { id: 0, name: "اعدادات المبيعات", color: -1 },
    { id: 1, name: "نقاط البيع", color: -1 },
    { id: 2, name: "اعدادات الورديات", color: -1 },
  ];

  const classes = useStylesAcc();
  const [saleSetting, setSaleSetting] = useState(typeSetting[0]);
  const [selectColor, setSelectColor] = useState({ id: 0, color: colors.blue[300] });

  const typSystem = [
    { id: 1, name: "تفعيل شاشة الفواتير" },
    { id: 3, name: "تقعيل شاشة المطاعم" },
    { id: 4, name: "تقعيل شاشة المحطات" },
    { id: 5, name: "تقعيل شاشة المغاسل" },
    { id: 6, name: "2تفعيل شاشة الفواتير" },
    { id: 7, name: "Plusتقعيل شاشة المطاعم" },
  ];
  const valueType = GetItemFromOptions(object?.invtype ?? 1, typSystem);

  const typePrices = [
    { id: 0, name: "التجزئة" },
    { id: 1, name: "الموزع" },
    { id: 2, name: "جملة" },
  ];
  const valuePrice = GetItemFromOptions(object?.type_sale_price ?? 1, typePrices);

  const clasTF = useStylesTF();
  const claslbl = useStylesLbl();
  const onRowClick = (row) => {
    setSaleSetting(row);
    setSelectColor({ ...row, color: colors.blue[300] });
  };
  return (
    <div className={classes.root}>
      <Accordion expanded={true}>

        <Grid item xs={12} container spacing={0} >

          <Grid item lg={2} md={2} sm={12} xs={12}>
            <Hidden smDown>
              <Paper
                style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
              >
                <SharedGroupIdProvider>
                  <GroupLists
                    groups={[...typeSetting]}
                    onRowClick={onRowClick}
                    isMain={true}
                    GroupColor={selectColor}
                  />
                  <Divider />
                </SharedGroupIdProvider>
              </Paper>
            </Hidden>
            <Hidden mdUp>
              <GroupSelectRest
                groups={[...typeSetting]}
                onRowClick={onRowClick}
                isMain={true}
                GroupColor={selectColor}
              />
            </Hidden>
          </Grid>

          <Grid item lg={10} md={10} sm={12} xs={12}>
            <div
              style={{ minHeight: "100%", maxHeight: "100%", overflow: "auto", }}
            >
              <SharedGroupIdProvider>
                {saleSetting.id == 0 ?
                  <>
                    <AccordionDetails className={classes.subTitle}>
                    </AccordionDetails>

                    <AccordionDetails >
                      <Grid item container spacing={1}>
                        {formData
                          ?.filter((d) => d.visible)
                          ?.map((item) => {
                            return (
                              <Grid xs={6}>
                                <CheckboxItem
                                  value={object[item.name] ?? null}
                                  name={item.name}
                                  label={item.label}
                                  onChange={onChange}
                                />
                              </Grid>
                            );
                          })}
                      </Grid>
                    </AccordionDetails>
                    <Grid container lg={12} md={12} sm={12} xs={12} spacing={1}>

                      <Grid item  lg={4} md={4} sm={6} xs={6}>
                        <Autocomplete
                          value={valueType}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "invtype",
                              value: newValue?.id,
                            });
                          }}
                          id="apply_discount"
                          size="small"
                          options={typSystem}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                          style={{}}
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              label="نوع النظام"
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item  lg={4} md={4} sm={6} xs={6}>
                        <Autocomplete
                          value={valuePrice}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "type_sale_price",
                              value: newValue?.id,
                            });
                          }}
                          id="type_sale_price"
                          size="small"
                          options={typePrices}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                          style={{}}
                          disableClearable
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              label="سعر البيع الافتراضي"
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item lg={2} md={2} sm={5} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                          id="No_Digit_Round"
                          label={"Copy Print Number"}
                          type="number"
                          className={clasTF.rootCust}
                          InputLabelProps={{ className: claslbl.clrBlackLblS }}
                          name="no_copies"
                          value={object.no_copies}
                          onChange={(event, newValue) => {
                            onChange(null, {
                              name: "no_copies",
                              value: event.target.value,
                            });
                          }}
                        />
                      </Grid>
                    </Grid>
                    <AccordionDetails>
                      {" "}
                      <Typography> {"إعدادات الخصومات مبيعات"}
                      </Typography>{" "}
                    </AccordionDetails>
                    <AccordionDetails style={{ backgroundColor: colors.grey[50] }}>
                      {object?.allow_discount ? <DiscountPermissions {...props} /> :
                        <Typography variant="h5" style={{ textAlign: "center" }}>
                          {"\n تاكد من تفعيل السماح بالخصم حتى يتم تفعيل الخيارات"}

                        </Typography>}
                    </AccordionDetails>
                    <Divider className={classes.divider} />
                  </>
                  : saleSetting.id == 1 ?
                    <POSPermissions
                      object={object}
                      onChange={onChange}
                      update={update}
                      gData={gData}
                    /> :
                    <ShiftsPermission   {...{ onChange, object, accounts }} />
                }

              </SharedGroupIdProvider>
            </div>
          </Grid>
        </Grid>

        <AccordionDetails className={classes.subTitle}>
          {" "}
          <Typography>
            {" "}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              disabled={props.submitting}
              onClick={update}
            >
              {"حفظ التعديلات"}
            </Button>
          </Typography>{" "}
        </AccordionDetails>
      </Accordion>
      <Swipeable />
    </div>
  );
}
